// src/components/ui/BellIcon.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { auth, db } from '../../config/firebase';
import { collection, query, where, orderBy, getDocs, onSnapshot } from 'firebase/firestore';

// Campana con contador de no leídas EN TIEMPO REAL (onSnapshot):
//  - notificacionesInternas dirigidas a este vigilante (leida === false)
//  - notificaciones del servicio que le aplican (to=all / sus tiendas / etc.)
const BellIcon = ({ servicioId }) => {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!servicioId || !auth.currentUser) return undefined;
    let unsubInternas = null;
    let unsubNotifs = null;
    let internas = 0;
    let firebaseCount = 0;
    const update = () => setCount(internas + firebaseCount);

    (async () => {
      try {
        const vigSnap = await getDocs(query(
          collection(db, 'servicios', servicioId, 'vigilantes'),
          where('email', '==', auth.currentUser.email),
        ));
        if (vigSnap.empty) return;
        const vigDoc = vigSnap.docs[0];
        const vigData = vigDoc.data();
        const tiendas = (vigData.tiendas || []).map((t) => t.numero).filter(Boolean);
        const deleted = vigData.deletedNotifications || [];

        unsubInternas = onSnapshot(
          query(collection(db, 'notificacionesInternas'), where('destinatarioId', '==', vigDoc.id)),
          (snap) => {
            internas = snap.docs.filter((d) => !d.data().leida).length;
            update();
          },
        );

        unsubNotifs = onSnapshot(
          query(collection(db, 'servicios', servicioId, 'notifications'), orderBy('createdAt', 'desc')),
          (snap) => {
            firebaseCount = snap.docs.filter((d) => {
              const n = d.data();
              if (n.deleted || deleted.includes(d.id)) return false;
              if (n.to === 'all') return true;
              const storeNumbers = n.data?.storeNumbers || [];
              if (storeNumbers.length > 0) return tiendas.some((t) => storeNumbers.includes(t));
              return n.to === 'cliente' || n.to === 'servicio';
            }).length;
            update();
          },
        );
      } catch (error) {
        console.error('Error al suscribirse al conteo de notificaciones:', error);
      }
    })();

    return () => {
      if (unsubInternas) unsubInternas();
      if (unsubNotifs) unsubNotifs();
    };
  }, [servicioId]);

  return (
    <button
      onClick={() => navigate('/notificaciones', { state: { servicioId } })}
      className="relative p-2 hover:bg-[#4678C3]/10 rounded-full transition-colors"
    >
      <Bell className="h-6 w-6 text-white" />
      {count > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs min-w-[20px] h-5 px-1 flex items-center justify-center rounded-full">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
};

export default BellIcon;
